import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BuilderCard from './builder-card';
import NextDestinationPanel from './next-destination-panel';
import _filter from 'lodash/filter';
import { AddBuilderItem, SetBuilderCity } from '../../../actions/builder';
import { builderListData, reservationData } from '../../../helpers/builderHelper';

class DestinationPanel extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      nextDestinationVisible:true,
      destinationVisible:false
    }
    this.onDestinationClose = this.onDestinationClose.bind(this);
    this.onAddDestination = this.onAddDestination.bind(this);
  }


  toggleViews(view){
    switch (view) {
      case 'nextDestination':
          this.setState({nextDestinationVisible:true, destinationVisible:false});
        break;
      case 'destination':
          this.setState({nextDestinationVisible:false, destinationVisible:true}, () => {
            document.querySelector('.destination-panel').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          });
        break;
      default:
        this.setState({nextDestinationVisible:true, destinationVisible:false});
    }
  }


  componentDidUpdate(prevProp, prevState){

    const {
      destinations,
      builderlist
    } = this.props;

    if(destinations !== prevProp.destinations){
      this.toggleViews('destination');
    }

    if(builderlist !== prevProp.builderlist){
     
      if(builderlist.data.length === 0){
        this.onDestinationClose();
      }
    }

  }

  onDestinationClose(){
    this.toggleViews('nextDestination');
  }


  onAddDestination(cityID, name, departureID, type, price, description, next){


    const {
      cities,
      cyoaProducts,
      AddBuilderItem,
      SetBuilderCity
    } = this.props;


    if(type === 'sector'){
      const cityData = _filter(cities, ['name', name])[0];
      AddBuilderItem(
        builderListData('sector', cityData, price, description, next, 0, "", reservationData(departureID, cityID)),
        reservationData(departureID, cityID)
      );
      SetBuilderCity(next);
    }
    if(type === 'product'){
      const productData = _filter(cyoaProducts, ['name', name])[0];
      AddBuilderItem(
        builderListData('product', productData, price, description, next, 0, departureID),
        null
      );
      SetBuilderCity(next);
    }


    this.onDestinationClose();
  }

  renderFixedProductMessage(){
    return(
      <div className="fixed-product-text">
        <span className="roundal">Or</span>
        <p>Link up with these popular tours</p>
      </div>
    )
  }

  renderDestinationPanel(){

    const { destinations, destination } = this.props;

    return (
      <div className="destination-panel">
        <div className="row">
          <div className="column small-10">
            <p className={`no-margin uppercase select-text ${destination}`}>Select next destination</p>
          </div>
          <div className="column small-2 text-right">
            <svg onClick={this.onDestinationClose} className="destination-close" width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.978 9.56l7.673-7.713a.678.678 0 0 0 0-.956l-.475-.478a.67.67 0 0 0-.951 0L9.552 8.127 1.88.418a.67.67 0 0 0-.95 0L.453.896a.678.678 0 0 0 0 .956L8.126 9.56.46 17.274a.678.678 0 0 0 0 .956l.475.478a.67.67 0 0 0 .95 0l7.667-7.714 7.673 7.714a.67.67 0 0 0 .95 0l.476-.478a.678.678 0 0 0 0-.956L10.978 9.56z" fill="#000000" fillRule="nonzero" opacity=".501"/>
            </svg>
          </div>
        </div>

        <div className="row margin-t-30">
          <div className="column small-12 destinations">
              {
                destinations.map((item, index) => {
                  return (
                    <Fragment key={index}>

                      { item.type === 'product' ? this.renderFixedProductMessage() : ''}

                       <BuilderCard
                          id={'next-destination-view'}
                          showClose={false}
                          showPlus={true}
                          data={item}
                          type={item.type}
                          image={_filter( (item.type === 'sector' || item.type === undefined) ? this.props.cities : this.props.cyoaProducts, ['name', item.name])[0] }
                          onPlusClicked={() => this.onAddDestination(item.tms_stage_id, item.name, item.departure_id, item.type, item.price, item.description, item.next)}
                        />

                    </Fragment>
                  )
                })
              }
          </div>
        </div>
      </div>
    )
  }


  render(){

    const { nextDestinationVisible, destinationVisible } = this.state;

    return (
      <Fragment>
        { nextDestinationVisible &&  <NextDestinationPanel /> }
        { destinationVisible && this.renderDestinationPanel() }
      </Fragment>
    )
  }
}


function mapStateToProps(state){
  return {
    cities:state.cities.data,
    destinations:state.destinations.data,
    cyoaProducts:state.cyoaProducts.data,
    currency:state.currency,
    builderlist:state.builderlist
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    AddBuilderItem,
    SetBuilderCity
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(DestinationPanel);



// WEBPACK FOOTER //
// ./src/components/builder/components/destination-panel.js